export default "__VITE_ASSET__J6p2jNoD__"